import { render } from "./DriverCleanupDashboard.vue?vue&type=template&id=ebe4c32e"
import script from "./DriverCleanupDashboard.vue?vue&type=script&lang=js"
export * from "./DriverCleanupDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__